import * as React from 'react';

import Image from '../atoms/Image';
import styles from './Awards.module.scss';

const Awards = () => (
  <div className={styles.content}>
    <ul className={styles.awards}>
      <li>
        <Image
          path="Award-HRTechAwards.png"
          alt="HRテクノロジー大賞"
          className={styles.awards__logo}
        />
      </li>
      <li>
        <Image
          path="Award-GoodDesignAward.png"
          alt="グッドデザイン賞　2019"
          className={styles.awards__logo}
        />
      </li>
      <li>
        <Image
          path="Award-RisingStarAward.png"
          alt="RISING STAR AWARD 2018"
          className={styles.awards__logo}
        />
      </li>
      <li>
        <Image
          path="Award-ASPICIoTAICloudAward.jpg"
          alt="ASPIC IoT・AI・クラウドアワード 2019"
          className={styles.awards__logo}
        />
      </li>
      <li>
        <Image
          path="Award-MizuhoInnovationAward.png"
          alt="Mizuho Innovation Award"
          className={styles.awards__logo}
        />
      </li>
    </ul>
  </div>
);

export default Awards;
